import { Field, ErrorMessage } from 'formik';
import FormikDatePickerWithTime from '../../../../../components/formInputs/formikDatePickerWithTime';
import AsyncTypeaheadSearch from '../../../../../components/commonLayouts/TypeaheadSearch/AsyncTypeaheadSearch';
import { useDispatch } from 'react-redux';
import InputWithDropdown from 'components/formInputs/InputWithDropdown';
import BuyerSupplierSearch from 'components/commonLayouts/TypeaheadSearch/BuyerSupplierSearch';
import { useDebounce } from '../DebouncedValue';
import { getDealCalculation } from '../../../../../redux/actions/transactionApi';
import React, { useState, useEffect } from 'react';
import { buildDealCalculationPayload } from '../RequestFinancing.helpers';
import {
    PAYMENT_TERM_OPTIONS,
    getDefaultEarlyPaymentForPaymentTerm,
    isEarlyPaymentValid,
} from '../../../../../utils/paymentTermUtils';

const DealDetails = (props) => {
    const dispatch = useDispatch();
    const debouncedDetail = useDebounce(props.formikProps.values, 500);
    const debouncedCharges = useDebounce(props.formikProps.values.additional_charges, 500);
    const debouncedProducts = useDebounce(props.formikProps.values.products, 500);
    const [errorImo, setErrorImo] = useState('');
    useEffect(() => {
        const payload = buildDealCalculationPayload({
            platformRole: props.role,
            orgId: props.id,
            associatedBuyer: props.associatedBuyer,
            buyerSupplierName: props.formikProps.values.buyer_supplier_name,
            products: debouncedProducts,
            charges: debouncedCharges,
            paymentTerm: props.formikProps.values.payment_term,
            earlyPayment: props.formikProps.values.early_payment_options,
            extendedCredit: props.formikProps.values.extended_credit_option,
            checked: props.formikProps.values.checked,
            transactionType: 'deal_financing',
            chargeProductNameKey: 'name',
        });
        payload.role = props?.role;

        dispatch(getDealCalculation(payload));
    }, [debouncedDetail, debouncedProducts, debouncedCharges]);

    const errorCheck = (a) => {
        const imoRegex = /^\d{7}$/; // Exactly 7 digits

        if (!imoRegex.test(a)) {
            setErrorImo('IMO number must be exactly 7 digits');
        } else {
            setErrorImo('');
            props.formikProps.setFieldValue('vessel_imo', a);
        }
    };

    return (
        <div className='accordion-item'>
            <h2 className='accordion-header' id='flush-headingOne'>
                <button
                    className='accordion-button collapsed accordion-title px-3'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#flush-collapseOne'
                    aria-expanded='false'
                    aria-controls='flush-collapseOne'>
                    Deal Details
                </button>
            </h2>
            <div
                id='flush-collapseOne'
                className='accordion-collapse collapse show'
                aria-labelledby='flush-headingOne'
                data-bs-parent='#accordionFlushExample'>
                <div className='accordion-body p-0 px-1 pb-4'>
                    <div className='col-10'>
                        <div className='row m-0 text-start'>
                            {(props.role === 'buyer' || props.role === 'broker') && (
                                <div className='col-4 mb-3'>
                                    
                                    

                                    <Field name='vessel_imo'>
                                        {({ field, form }) => {
                                            const formattedVessels = (props.allVessels || []).map(
                                                (v) => ({
                                                    ...v,
                                                    displayName: v.name
                                                        ? `${v.name} | ${v.imo_number}`
                                                        : `${v.imo_number}`,
                                                })
                                            );
                                            return (
                                                <InputWithDropdown
                                                    label='Vessel IMO'
                                                    options={formattedVessels}
                                                    placeholder='Type or select'
                                                    labelKey={'displayName'}
                                                    value={field.value}
                                                    onChange={(a, option) => {
                                                        const valToCheck = option
                                                            ? option.imo_number
                                                            : a;
                                                        errorCheck(valToCheck);
                                                        props.handleVessleIMOChange(
                                                            valToCheck,
                                                            option,
                                                            props.formikProps,
                                                            form
                                                        );
                                                    }}
                                                />
                                            );
                                        }}
                                    </Field>
                                    {errorImo && <div className='error-message font-b4 text-error-700'>{errorImo}</div>}
                                    
                                </div>
                            )}
                            <div className='col-4 mb-3'>
                                

                                <Field name='port'>
                                    {({ field, form }) => (
                                        <AsyncTypeaheadSearch
                                            name='port'
                                            label={{
                                                id: 'port',
                                                name: 'Port',
                                                placeholder: 'Select Port',
                                            }}
                                            isMultiSelections={false}
                                            handleOnChange={(selected) => {
                                                props.formikProps.setFieldValue('port', selected);
                                                props.handlePortChange(selected);
                                            }}
                                            error={form.errors.port && form.touched.port}
                                            errorMessage={form.errors.port}
                                        />
                                    )}
                                </Field>
                                
                            </div>
                            <div className='col-4 mb-3'>
                                
                                <Field name='next_port'>
                                    {({ field, form }) => (
                                        <AsyncTypeaheadSearch
                                            name='next_port'
                                            label={{
                                                name: 'Next Port (Optional)',
                                                id: 'next_port',
                                                placeholder: 'Select Port',
                                            }}
                                            handleOnChange={(selected) => {
                                                props.formikProps.setFieldValue('next_port', selected);
                                            }}
                                            error={form.errors.next_port && form.touched.next_port}
                                            errorMessage={form.errors.next_port}
                                        />
                                    )}
                                </Field>
                            </div>
                            <div className='col-4 mb-3'>
                                <label className='form-label text-neutral-800 font-b3 mb-1'>
                                    Estimated Delivery Start Date
                                </label>

                                
                                <Field
                                    name='delivery_start_date'
                                    id='delivery_start_date'
                                    className='form-control font-b2'
                                    component={FormikDatePickerWithTime}
                                />
                                <ErrorMessage
                                    name='delivery_start_date'
                                    component='div'
                                    className='error-message font-b4 text-error-700'
                                />
                            </div>
                            <div className='col-4 mb-3'>
                                <label className='form-label text-neutral-800 font-b3 mb-1'>
                                    Estimated Delivery End Date
                                </label>
                                <Field
                                    name='delivery_end_date'
                                    id='delivery_end_date'
                                    className='form-control font-b2'
                                    component={FormikDatePickerWithTime}
                                />
                                

                                <ErrorMessage
                                    name='delivery_end_date'
                                    component='div'
                                    className='error-message font-b4 text-error-700'
                                />
                            </div>

                            <div className='col-4 mb-3'>
                                <label className='form-label text-neutral-800 font-b3 mb-1'>Payment Term</label>
                                <Field
                                    as='select'
                                    name='payment_term'
                                    className='form-control font-b2'
                                    onChange={(e) => {
                                        const newValue = e.target.value;

                                        props.formikProps.setFieldValue('payment_term', newValue);
                                        if (props.role === 'supplier') {
                                            const currentEarlyPayment =
                                                props.formikProps.values.early_payment_options;
                                            if (!isEarlyPaymentValid(newValue, currentEarlyPayment)) {
                                                props.formikProps.setFieldValue(
                                                    'early_payment_options',
                                                    getDefaultEarlyPaymentForPaymentTerm(newValue),
                                                );
                                            }
                                        }
                                    }}>
                                    {PAYMENT_TERM_OPTIONS.map((opt) => (
                                        <option key={opt.value} value={opt.value} label={opt.label} />
                                    ))}
                                </Field>

                                <ErrorMessage
                                    name='payment_term'
                                    component='div'
                                    className='error-message font-b4 text-error-700'
                                />
                            </div>

                            {(props.role === 'buyer' || props.role === 'broker') && (
                                <div className='col-4 mb-3'>
                                    <label className='form-label text-neutral-800 font-b3 mb-1'>Supplier Name</label>
                                    <Field as='select' name='buyer_supplier_name' className='form-control font-b2'>
                                        <option value='' label='Select Option' />
                                        {props.supplierList?.map((supplier) => (
                                            <option key={supplier.ulid} value={supplier.ulid}>
                                                {supplier.name}
                                            </option>
                                        ))}
                                    </Field>
                                    <p className='font-b4 text-neutral-700 mt-1 mb-0'>
                                        If the preferred Supplier is not in the list, please contact 129Knots internal
                                        ops.
                                    </p>
                                    <ErrorMessage
                                        name='buyer_supplier_name'
                                        component='div'
                                        className='error-message font-b4 text-error-700'
                                    />
                                </div>
                            )}
                            {props.role === 'supplier' && (
                                <>
                                    <div className='col-4 mb-3'>
                                        
                                        <Field name='port'>
                                            {({ field, form }) => (
                                                <BuyerSupplierSearch
                                                    name='buyer_supplier_name'
                                                    label={{
                                                        id: 'buyer_supplier_name',
                                                        name: 'Buyer Name',
                                                        placeholder: 'Select',
                                                    }}
                                                    handleOnChange={(selected) => {
                                                        props.formikProps.setFieldValue(
                                                            'buyer_supplier_name',
                                                            selected
                                                        );
                                                        props.handlePortChange(selected);
                                                        selected &&
                                                            props.handleBuyerChange(
                                                                selected[0]?.buyer_organization_ulid
                                                            );
                                                        selected &&
                                                            props.setSelectedBuyerName(selected[0]?.buyer_organization_name);
                                                    }}
                                                    error={
                                                        form.errors.buyer_supplier_name &&
                                                        form.touched.buyer_supplier_name
                                                    }
                                                    errorMessage={form.errors.buyer_supplier_name}
                                                />
                                            )}
                                        </Field>
                                        

                                        <ErrorMessage
                                            name='buyer_name'
                                            component='div'
                                            className='error-message font-b4 text-error-700'
                                        />
                                    </div>
                                    <div className='col-4 mb-3'>
                                        <Field name='vessel_imo'>
                                            {({ field, form }) => {
                                                const formattedVessels = (props.allVessels || []).map(
                                                    (v) => ({
                                                        ...v,
                                                        displayName: v.name || v.vessel_name
                                                            ? `${v.name || v.vessel_name} | ${v.imo_number}`
                                                            : `${v.imo_number}`,
                                                    })
                                                );
                                                return (
                                                    <InputWithDropdown
                                                        label='Vessel IMO'
                                                        options={formattedVessels}
                                                        placeholder='Type or select'
                                                        labelKey={'displayName'}
                                                        value={field.value}
                                                        isDisabled={!props.formikProps.values.buyer_supplier_name}
                                                        onChange={(a, option) => {
                                                            const valToCheck = option
                                                                ? option.imo_number
                                                                : a;
                                                            errorCheck(valToCheck);
                                                            props.handleVessleIMOChange(
                                                                valToCheck,
                                                                option,
                                                                props.formikProps,
                                                                form
                                                            );
                                                        }}
                                                    />
                                                );
                                            }}
                                        </Field>
                                        {errorImo && (
                                            <div className='error-message font-b4 text-error-700'>{errorImo}</div>
                                        )}

                                        
                                        {!props.formikProps.values.buyer_supplier_name && (
                                            <div className='text-neutral-700 font-b4'>
                                                Please select a buyer to enable this field
                                            </div>
                                        )}
                                        
                                    </div>
                                </>
                            )}
                            <div className='col-4 mb-3'>
                                <label className='form-label text-neutral-800 font-b3 mb-1'>Delivery Mode</label>
                                <Field as='select' name='delivery_mode' className='form-control font-b2'>
                                    <option value='' label='Select Delivery Mode' />
                                    <option value='barge' label='Barge' />
                                    <option value='truck' label='Truck' />
                                    <option value='ship_to_ship' label='Ship to Ship' />
                                    <option value='ex_pipe' label='Ex-pipe' />
                                </Field>

                                <ErrorMessage
                                    name='delivery_mode'
                                    component='div'
                                    className='error-message font-b4 text-error-700'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DealDetails;
